import { getBanks } from '@/services/banks.service';
import { getProviderFiles } from '@/services/providerFiles.service';
import { getProviderCBUs } from '@/services/providers.service';

const Model = {
  namespace: 'providersList',

  state: {
    banks: [],
    providerFiles: [],
    providerFilesLoading: false,
    providerCbus: [],
    providerCbusLoading: false,
  },

  effects: {
    *fetchBanks(_, { call, put }) {
      try {
        const response = yield call(getBanks);
        yield put({
          type: 'setData',
          payload: { banks: Array.isArray(response.data) ? response.data : [] },
        });
      } catch {}
    },

    *fetchProviderFiles({ payload }, { call, put }) {
      yield put({ type: 'setData', payload: { providerFilesLoading: true, providerFiles: [] } });
      try {
        const response = yield call(getProviderFiles, { provider: payload.providerId, page: 1, page_size: 10 });
        const data = Array.isArray(response.data) ? response.data : response.data?.results || [];
        yield put({ type: 'setData', payload: { providerFiles: data, providerFilesLoading: false } });
      } catch {
        yield put({ type: 'setData', payload: { providerFilesLoading: false } });
      }
    },

    *fetchProviderCbus({ payload }, { call, put }) {
      yield put({ type: 'setData', payload: { providerCbusLoading: true, providerCbus: [] } });
      try {
        const response = yield call(getProviderCBUs, payload.providerId);
        const data = Array.isArray(response.data) ? response.data : response.data?.results || [];
        yield put({ type: 'setData', payload: { providerCbus: data, providerCbusLoading: false } });
      } catch {
        yield put({ type: 'setData', payload: { providerCbusLoading: false } });
      }
    },
  },

  reducers: {
    setData(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};

export default Model;
